var gallerySwiper = new Swiper('.news-gallery .swiper-container', {
	slidesPerView: 1,
	navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    allowTouchMove: $(".news-gallery .swiper-slide").length > 1 ? true : false,
});

if($(".news-gallery .swiper-slide").length > 1){
	
}else{
	$(".news-gallery .swiper-button-prev, .news-gallery .swiper-button-next").hide();
}